export default __webpack_public_path__ + "img/linkedin.c0d68435.png";